var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-control",attrs:{"id":_vm.getId(),"type":"text","disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){_vm.onInput($event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }